import { allowedFileTypes, fileTypeToLogo, parseFileInfo } from '@/shared/utils/filesUtils'
import Paragraph from '@/shared/v2/shared/components/Paragraph'
import Image from 'next/image'
import React from 'react'

interface ImageFileTypeLogoProps {
    file: File
}

const ImageFileTypeLogo: React.FC<ImageFileTypeLogoProps> = ({ file }) => {
    const fileInfo = parseFileInfo({ file })

    return allowedFileTypes.includes(file.type) ? (
        <div className="box-border min-w-6 min-h-8 w-6 h-8">
            <Image alt={fileInfo?.name ?? file.name} src={fileTypeToLogo(fileInfo?.type)} />
        </div>
    ) : (
        <div className="flex box-border items-center justify-center bg-backgroundInformationLight border border-borderPrimary pt-6 px-1 rounded-tr-4">
            <Paragraph size={3} color="lightGrey">
                {fileInfo?.type?.toUpperCase()}
            </Paragraph>
        </div>
    )
}

export default ImageFileTypeLogo
